<template>
  <main class="page-content">
    <landing/>
    <rosa-graf/>
    <services/>
    <voucher/>
    <contact/>
  </main>
</template>

<script>
import Landing from '../components/Landing';
import Services from "../components/Services";
import RosaGraf from "../components/RosaGraf";
import Contact from "../components/Contact";
import Voucher from "../components/Voucher";

export default {
  name: "Cosmetics",
  components: {
    Voucher,
    RosaGraf,
    Services,
    Landing,
    Contact
  },
  methods: {
    animationsOnScroll() {
      const options = {
        root: null,
        threshold: 0,
        rootMargin: '0px 0px -300px 0px'
      };

      const observer = new IntersectionObserver(function (entries) {
        entries.forEach(entry => {
          if (!entry.isIntersecting) {
            return;
          } else {
            entry.target.classList.add('appear');
            observer.unobserve(entry.target);
          }
        });
      }, options);

      const faders = document.querySelectorAll('.fade-in');
      const sliders = document.querySelectorAll('.slide-in');

      faders.forEach(fader => {
        observer.observe(fader);
      });

      sliders.forEach(slider => {
        observer.observe(slider);
      });
    }
  },
  mounted() {
    this.animationsOnScroll();
  },
  metaInfo: {
    title: 'Beautyful Cosmetics',
    titleTemplate: '%s | Haarlem Friseure',
    meta: [
      {charset: 'utf-8'},
      {name: 'viewport', content: 'width=device-width, initial-scale=1'},
      {
        name: 'description',
        content: 'Bei Beautyful Cosmetics geht es rund um das Thema Kosmetik und Wellness. Ob Peelings, Massagen oder Pediküren - bei uns finden Ihre Bedürfnisse anklang. Jetzt informieren!'
      },
      {
        property: 'og:site_name', content: 'Beautyful Cosmetics | Haarlem Friseure'
      },
      {
        property: 'og:type', content: 'website'
      },
      {
        name: 'robots', content: 'index,follow'
      }
    ]
  }
}
</script>

<style scoped lang="scss">
@import 'src/assets/scss/imports';

</style>
